<template>
    <b-row>
        <b-col>
            <div class="collapsible collapsible__add collapsed">
            <div class="collapsible-heading">
                <div class="d-flex">
                    <div class="collapsible-heading__image" @click="onClickButton()" :style="imageStyle">
                        <font-awesome-icon icon="plus-circle" style="font-size: 21pt;" />
                    </div>
                    <div class="flex-grow-1 collapsible-heading__title" @click="onClickButton()"><slot></slot></div>
                </div>
            </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ''
        }
    },
    computed: {
        imageStyle() {
            return `padding-left: ${this.pl}px; padding-right: ${this.pr}px;`;
        }
    },
    methods: {
        onClickButton() {
            this.$emit('click');
        }
    },
}
</script>